<template>
    <v-tooltip open-delay="1000">
        <template v-slot:activator="{ props }">
            <div v-bind="(user || id) ? props : undefined" class="d-flex align-items-center">
                <v-avatar v-if="company" icon="mdi-domain" :size="size" class="ma-1" :title="description"></v-avatar>
                <v-avatar v-if="group" icon="mdi-account-multiple" :size="size" class="ma-1" :title="description"></v-avatar>
                <avatar-view v-if="account" :user="account" :size="size" class="ma-1"></avatar-view>
                <div v-if="message != null" :title="description">
                    <b>{{ content }}</b>
                    <span v-if="message != null" class="content-message">{{ message }}</span>
                </div>
                <div v-else-if="payload == null" :title="description">
                    {{ content }}
                </div>
                <div v-else>
                    <router-link :payload="payload" :title="description">{{ content }}</router-link>
                </div>
            </div>
        </template>
        <v-lazy>
            <user-detail :user="account" v-if="account" />
        </v-lazy>
    </v-tooltip>
</template>

<script>
import AvatarView from './AvatarView.vue';
import Utils from '../utils';
import RouterLink from './RouterLink.vue';
import UserDetail from './UserDetail.vue';

export default {
    components: {
        UserDetail, RouterLink, AvatarView,
    },
    name: 'UserView',
    props: {
        id: String,
        user: Object,
        company: Object,
        group: Object,
        payload: Object,
        message: undefined,
        size: {
            type: Number,
            default: 24,
        },
    },
    computed: {
        account() {
            if (this.user) {
                return this.user;
            } if (this.id) {
                return this.$api.get_user(this.id);
            }
            return undefined;
        },
        content() {
            const user = this.account;
            if (user != null) {
                return Utils.userToString(user);
            }
            const company = this.company;
            if (company != null) {
                return Utils.companyToString(company);
            }
            const group = this.group;
            if (group != null) {
                return group.name;
            }
            return '';
        },
        description() {
            const user = this.account;
            if (user != null) {
                return null;
            }
            const company = this.company;
            if (company != null) {
                return company.desc;
            }
            const group = this.group;
            if (group != null) {
                return group.desc;
            }

            return undefined;
        },
    },
};
</script>

<style scoped>
.content-message {
    padding-left: 4px;
}
</style>
<style>
.v-tooltip .v-overlay__content {
  background: rgba(var(--v-theme-surface-variant), 0.95);
}
</style>
